import React from "react"
import PropTypes from "prop-types"
import { Divider, Typography, Flex } from "antd"
import { useTranslation } from "react-i18next"
import styles from "./index.module.css"
import { spacings } from "themes/variables"
import { Text } from "ui/Typography"
import { Icons } from "assets/icons"
import ExternalLink from "ui/Icon/DSIcon/ExternalLink"
import { generateTripLink } from "./utils"

const AssignedExperienceNoActiveBooking = ({ list = [], assignedExperiences = [], warning }) => {
  const { t } = useTranslation()

  // Use assignedExperiences if provided and list is empty, otherwise use list
  const experiencesList = list.length > 0 ? list : assignedExperiences

  if (!experiencesList.length) return null

  return (
    <div className={styles.mt16}>
      <div className={styles.assignedExperiences}>
        {t("equipment.modals.assigned_experiences")} ({experiencesList.length})
      </div>
      {warning && (
        <Flex align="center" gap={spacings.XS} className={styles.warningAlert}>
          <Icons.OrangeAlertTriangle />
          <Text>{warning}</Text>
        </Flex>
      )}
      <div>
        {experiencesList.map((item, idx) => {
          const { trip_name, name, trip_id, status } = item || {}
          const tripName = trip_name || name
          const tripLink = generateTripLink({ trip_id, status })

          return (
            <>
              <Flex key={tripName + idx} gap={spacings.XS} align="center">
                <Typography.Link href={tripLink} target="_blank" rel="noopener noreferrer" className={styles.externalLink}>
                  {tripName}
                  <ExternalLink className="ml-xxs" />
                </Typography.Link>

              </Flex>
              <Divider />
            </>
          )
        })}
      </div>
    </div>
  )
}

AssignedExperienceNoActiveBooking.propTypes = {
  list: PropTypes.array,
  assignedExperiences: PropTypes.array,
  warning: PropTypes.string
}

export default AssignedExperienceNoActiveBooking
